import { fieldRef, constant, op } from './astHelpers';

/** Quantity × Rate: MULTIPLY(qty, rate) */
export const buildQuantityRateFormula = (cfg = {}) => {
  const qty = cfg.quantityFieldCode
    ? fieldRef(cfg.quantityFieldCode)
    : constant(cfg.quantityValue ?? 0);
  const rate = cfg.rateFieldCode
    ? fieldRef(cfg.rateFieldCode)
    : constant(cfg.rateValue ?? 0);
  if (!cfg.quantityFieldCode && cfg.quantityValue == null && !cfg.rateFieldCode && cfg.rateValue == null) {
    return null;
  }
  return op('MULTIPLY', [qty, rate]);
};
